<template>
  <span class="flex w-full items-center gap-8">
    <p
      v-if="
        familyStore.selectedFamilyPlanBundlePrice &&
        familyStore.selectedFamilyPlanBundlePrice.Plan?.RegularDataAllowance
      "
      class="heading-xxs text-text-on-highlight strike-through"
    >
      {{
        familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularDataAllowance?.toString()
      }}
    </p>

    <p class="heading-xs text-text-on-highlight">
      {{
        familyStore.selectedFamilyPlanBundlePrice?.Plan?.DataAllowance?.toString()
      }}
      GB
    </p>

    <span class="flex flex-col md:items-end ml-auto">
      <p
        v-if="
          familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee
        "
        class="heading-xxs text-text-on-highlight"
      >
        Prissänkning
      </p>
      <span class="flex gap-8">
        <p
          v-if="
            familyStore.selectedFamilyPlanBundlePrice &&
            familyStore.selectedFamilyPlanBundlePrice.Plan?.RegularMonthlyFee
          "
          class="heading-xxs text-text-on-highlight strike-through"
          aria-hidden="true"
        >
          {{
            familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee
          }}
        </p>
        <span
          v-if="
            familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee
          "
          class="sr-only"
        >
          {{
            `Tidigare ${familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee} kronor i månaden, nu `
          }}
        </span>
        <p class="heading-xxs text-text-on-highlight" aria-hidden="true">
          {{ familyStore.selectedFamilyPlanBundlePrice?.Plan?.MonthlyFee }}
          kr/mån
        </p>
        <span class="sr-only"
          >{{
            familyStore.selectedFamilyPlanBundlePrice?.Plan?.MonthlyFee
          }}
          kronor i månaden</span
        >
      </span>
    </span>
  </span>
</template>
<script lang="ts" setup>
const familyStore = useFamilyStore();
</script>
<style scoped lang="scss">
.strike-through {
  &:before {
    background: linear-gradient(
      to left top,
      transparent 45.5%,
      var(--text-on-highlight) 47.5%,
      var(--text-on-highlight) 52.5%,
      transparent 54.5%
    ) !important;
  }
}
</style>
